/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { GroupAction } from '../group-action';
import { StandardAction } from '../../tool/action/standard-action';

export class PdfOptions {
  public get showPrint(): boolean {
    return this._showPrint;
  }

  public set showPrint(value: boolean) {
    this._showPrint = value;
    this.initActions();
  }
  public get showRotation(): boolean {
    return this._showRotation;
  }

  public set showRotation(value: boolean) {
    this._showRotation = value;
    this.initActions();
  }
  public get showZoom(): boolean {
    return this._showZoom;
  }

  public set showZoom(value: boolean) {
    this._showZoom = value;
    this.initActions();
  }
  public get showSearch(): boolean {
    return this._showSearch;
  }

  public set showSearch(value: boolean) {
    this._showSearch = value;
    this.initActions();
  }
  public get showDownload(): boolean {
    return this._showDownload;
  }

  public set showDownload(value: boolean) {
    this._showDownload = value;
    this.initActions();
  }
  public get showResize(): boolean {
    return this._showResize;
  }

  public set showResize(value: boolean) {
    this._showResize = value;
    this.initActions();
  }
  public get showNavPages(): boolean {
    return this._showNavPages;
  }

  public set showNavPages(value: boolean) {
    this._showNavPages = value;
    this.initActions();
  }
  public get withBorder(): boolean {
    return this._withBorder;
  }

  public set withBorder(value: boolean) {
    this._withBorder = value;
    this.initActions();
  }
  public get fitToPage(): boolean {
    return this._fitToPage;
  }

  public set fitToPage(value: boolean) {
    this._fitToPage = value;
    this.initActions();
  }

  public get originalSize(): boolean {
    return this._originalSize;
  }

  public set originalSize(value: boolean) {
    this._originalSize = value;
    this.initActions();
  }

  public set showSignature(value: boolean) {
    this._showSignature = value;
    this.initActions();
  }
  public get showSignature(): boolean {
    return this._showSignature;
  }

  private _showAll = true;
  public get showAll(): boolean {
    return this._showAll;
  }
  public set showAll(value: boolean) {
    this._showAll = value;
    this._fitToPage = value;
    this._withBorder = value;
    this._showNavPages = value;
    this._showResize = value;
    this._showDownload = value;
    this._showSearch = value;
    this._showZoom = value;
    this._showRotation = value;
    this._showPrint = value;
    this._showSignature = value;
    this._originalSize = value;
    this.initActions();
  }

  private _fitToPage = true;
  private _originalSize = true;
  private _withBorder: boolean;
  private _showNavPages: boolean;
  private _showResize = true;
  private _showDownload = true;
  public downloadText: string;
  private _showSearch = true;
  private _showZoom = true;
  private _showRotation = true;
  private _showPrint = true;
  private _showSignature = false;

  public groups: GroupAction[] = [];
  public basicGroup: GroupAction;

  constructor() {
    this.initActions();
  }

  private initActions() {
    if (this.basicGroup) {
      this.basicGroup.actions = [];
    } else {
      this.basicGroup = new GroupAction('basic', []);
      this.groups.push(this.basicGroup);
    }
    if (this.showNavPages) {
      this.basicGroup.addAction(
        new StandardAction(
          'previousPage',
          'arrow-circle-up',
          null,
          'pdf.tooltip.previousPage',
        ),
      );
      this.basicGroup.addAction(
        new StandardAction(
          'nextPage',
          'arrow-circle-down',
          null,
          'pdf.tooltip.nextPage',
        ),
      );
    }
    if (this.showZoom) {
      this.basicGroup.addAction(
        new StandardAction(
          'zoomMinus',
          'minus-circle',
          null,
          'pdf.tooltip.zoomMinus',
        ),
      );
      this.basicGroup.addAction(
        new StandardAction(
          'zoomPlus',
          'plus-circle',
          null,
          'pdf.tooltip.zoomPlus',
        ),
      );
    }
    if (this.showResize) {
      this.basicGroup.addAction(
        new StandardAction(
          'resize',
          'expand-arrows',
          null,
          'pdf.tooltip.resize',
        ),
      );
    }
    if (this.showRotation) {
      this.basicGroup.addAction(
        new StandardAction('rotation', 'redo', null, 'pdf.tooltip.rotation'),
      );
    }
    if (this.showSearch) {
      this.basicGroup.addAction(
        new StandardAction('search', 'search', null, 'pdf.tooltip.search'),
      );
    }
    if (this.showSignature) {
      this.basicGroup.addAction(
        new StandardAction('sign', 'file-signature', null, 'pdf.tooltip.sign'),
      );
    }
    if (this.showPrint) {
      this.basicGroup.addAction(
        new StandardAction('print', 'print', null, 'pdf.tooltip.print'),
      );
    }
    if (this.showDownload) {
      this.basicGroup.addAction(
        new StandardAction(
          'download',
          'download',
          this.downloadText,
          'pdf.tooltip.download',
        ),
      );
    }
    this.basicGroup.addAction(
      new StandardAction('close', 'times', null, 'pdf.tooltip.close'),
    );
    this.groups[0].align = 'right';
  }

  addGroupAction(group: GroupAction, index?: number) {
    if (index !== null && index !== undefined) {
      this.groups.splice(index, 0, group);
    } else {
      this.groups.push(group);
    }
  }
}
